import { render, staticRenderFns } from "./SummaryOptions.vue?vue&type=template&id=c0c40958&scoped=true"
import script from "./SummaryOptions.vue?vue&type=script&lang=js"
export * from "./SummaryOptions.vue?vue&type=script&lang=js"
import style0 from "./SummaryOptions.vue?vue&type=style&index=0&id=c0c40958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c40958",
  null
  
)

export default component.exports